import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loader = ({ size = 36, minHeight = 160, fullScreen = false, color = 'primary' }) => (
  <Box
    sx={{
      position: fullScreen ? 'fixed' : 'relative',
      inset: fullScreen ? 0 : undefined,
      minHeight: fullScreen ? undefined : minHeight,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: (theme) => (fullScreen ? theme.zIndex.modal + 1 : 1),
    }}
  >
    <CircularProgress size={size} color={color} thickness={4} />
  </Box>
);

export default Loader;